
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import Picker from '../Picker'
import PickersList from '../PickersList'

import translations from './PickerStorage.translations'

export default {
  components: {
    Picker,
    PickersList,
  },

  props: {
    activeBackboxGrade: {
      type: Number,
      default: 0,
    },
    displayVariant: {
      type: Boolean,
      default: false,
    },
    storages: {
      type: Array,
      default: () => [],
    },
    clickOnLinkPicker: {
      type: Function,
      default: () => {},
    },
    loadingId: {
      type: String,
      default: null,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  computed: {
    translations: () => translations,

    displayStorages() {
      return this.displayVariant && !isEmpty(this.storages)
    },

    sortedStorages() {
      return [...this.storagesWithLink].sort((a, b) => {
        const comparison = a.sortingKey > b.sortingKey

        return comparison ? 1 : -1
      })
    },

    storagesWithLink() {
      return this.storages.map((storage) => {
        return {
          ...storage,
          link: {
            ...storage.link,
            hash: { l: this.activeBackboxGrade, scroll: false },
          },
          isLoading: storage.id === this.loadingId,
        }
      })
    },

    hasLoadingId() {
      return this.loadingId !== null
    },
  },

  methods: {
    storageClick({ available, selected, name, id }) {
      if (available) {
        if (!selected) {
          trackClick({ zone: 'storage_picker', name })
        }
        this.clickOnLinkPicker(id)
      }
    },
    blockPickerSelection(picker) {
      return this.hasLoadingId || !picker.available
    },
  },
}
